import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    // customMessageKey: string,
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    countryPlaceholder: 'Country',
    emailAddressPlaceholder: 'Email address',
    firstNamePlaceholder: 'First name',
    lastNamePlaceholder: 'Last name',
    postalCodePlaceholder: 'Postal code',
    statusPlaceholder: 'Status',
    organizationPlaceholder: 'Organization',
    verifyMyMedicalProfessionalStatus: 'VERIFY MY PROFESSIONAL STATUS',
    step: {
        personalInfo: {
            title: 'UNLOCK THIS HEALTHCARE-PROFESSIONAL-ONLY OFFER',
            subtitle: "Verify you're a healthcare professional.",
        },
        docUpload: {
            title: 'WE NEED YOUR LICENSE OR CERTIFICATE',
            subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
        },
    },
};
